import type { Connector } from "wagmi"

type WagmiConnection = {
  connector: Connector
}

type WagmiDisconnect = {
  disconnect: (params?: { connector?: Connector }) => unknown
  disconnectAsync?: (params?: { connector?: Connector }) => Promise<unknown>
}

type Params = {
  connections: WagmiConnection[]
  accountAddress?: string
  disconnectClient: WagmiDisconnect
}

export async function disconnectWagmiConnections({
  connections,
  accountAddress,
  disconnectClient,
}: Params): Promise<void> {
  // wagmi can transiently report zero connections while an account is still set
  // during reconnect; force a connector-less disconnect to clear stale state.
  if (connections.length === 0 && accountAddress != null) {
    if (disconnectClient.disconnectAsync) {
      await disconnectClient.disconnectAsync()
    } else {
      disconnectClient.disconnect()
    }
    return
  }

  const disconnects = connections.map(({ connector }) => {
    if (disconnectClient.disconnectAsync) {
      return disconnectClient.disconnectAsync({ connector })
    }
    return Promise.resolve(disconnectClient.disconnect({ connector }))
  })

  await Promise.all(disconnects)
}
